/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import moment from 'moment-timezone';
import { get, isEmpty, isArray, clone } from 'lodash';

// Components
import AppContainerPicker from 'shared/ui/components/form-components/pickers/AppContainerPicker.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import DatetimePicker from 'shared/ui/components/form-components/pickers/DatetimePicker.vue';
import Dialog from 'shared/ui/components/modals/DialogComponent.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';
import WorkspaceCategory from 'shared/ui/components/form-components/WorkspaceCategory.vue';

// Mixins
import settings from './settings';

const __vue_script__ = {
    name: 'WorkspaceInfo',

    components: { AppContainerPicker, BaseInput, BaseSelect, Checkbox, DatetimePicker, Toggler, WorkspaceCategory },

    mixins: [settings],

    data() {
        const stages = [{
            _id: 'preprod',
            label: this.$t('general_settings.form.stages.preprod'),
            value: 'preproduction'
        }, {
            _id: 'prod',
            label: this.$t('general_settings.form.stages.prod'),
            value: 'production'
        }];

        if (this.event.lifecycle.stage === 'sandbox') {
            // Note: this value is never used and it's for the exclusive
            // benefit of the UI to not break under a test event.
            // This is a stylistic choice, because it's easier than
            // always check `if !this.event.test_event` each time something
            // happens arount the stage value.
            stages.push({
                _id: 'test',
                label: 'Sandbox workspace (limited lifetime)',
                value: 'sandbox'
            });
        }

        return {
            apps: [],
            baseTemplate: null,
            category: null,
            categories: null,
            containerApp: null,
            currentBranding: {},
            forceWhiteListBranding: false,
            hasMultiCategory: false,
            isCategoryEnabled: false,
            isMembershipAppInstalled: false,
            org: null,
            orgDisabled: false,
            organization: {},
            organizations: [],
            orgHasChanged: false,
            orgsLoading: true,
            parentEvent: null,
            parentEventWarnShown: false,
            userEvents: [],
            whitelistBranding: false,
            stage: null,
            stages,
            innerValue: {
                branded_app: '',
                enddate: new Date(),
                eventname: '',
                ownerId: '',
                startdate: new Date(),
                stage: '',
                description: {
                    start_time: 0,
                    end_time: 0
                },
                webapp: {},
                native: {},
                lifecycle: {}
            }
        };
    },

    computed: {
        containerAppObj() {
            return this.apps.find(app => app.fp_ext_id === this.containerApp);
        },

        /** @returns {Date} */
        minStartDate() {
            if (this.userIsAdminOrSupport) {
                return '';
            }

            let min = moment().tz(this.event.timezone);

            if (this.innerValue.end_date) {
                const endMinusMonth = moment(this.innerValue.end_date)
                    .tz(this.event.timezone)
                    .subtract(1, 'month');

                min = endMinusMonth.isBefore(min) ? min : endMinusMonth;
            }

            return min.startOf('day').toDate();
        },

        /** @returns {Date} */
        maxEndDate() {
            if (this.userIsAdminOrSupport || get(this.organization, 'workspace_defaults.unrestricted_workspace_duration')) {
                return '';
            }

            const start = this.innerValue.start_date ? this.innerValue.start_date : Date.now();

            return moment(start)
                .tz(this.event.timezone)
                .add(1, 'month')
                .startOf('day')
                .toDate();
        },

        /** @returns {boolean} */
        canChangeEndDate() {
            const eventEndTs = get(this.event, ['description', 'end_time']);
            const endOfTodayTs = moment().endOf('day').unix();

            return this.canChangeDate || !eventEndTs || eventEndTs >= endOfTodayTs;
        },

        /** @returns {boolean} */
        canChangeContainerApp() {
            return this.orgId && this.isUserPartOfOrg(this.orgId) || this.userIsSuperAdmin;
        },

        /** @returns {boolean} */
        showParentContainerAppOption() {
            return this.isMembershipAppInstalled;
        },

        /** @returns {boolean} */
        showAdvancedOptionsFieldset() {
            return this.showParentContainerAppOption;
        },

        /** @returns {string} */
        orgId() {
            return this.org ? this.org.value : this.event.ownerId;
        }
    },

    watch: {
        async org(opt) {
            this.innerValue.ownerId = opt.value;
            await this.initOrgData();
            this.orgHasChanged = opt.value !== this.event.ownerId;
        },

        category(opt) {
            if (isArray(opt)) {
                delete this.innerValue.description.category;
                this.innerValue.description.categories = opt;
            } else {
                delete this.innerValue.description.categories;
                this.innerValue.description.category = opt;
            }
        },

        parentEvent(opt) {
            this.innerValue.parent_event = opt?._id || null;

            if (!this.parentEventWarnShown && this.innerValue.parent_event) {
                this.parentEventWarnShown = true;
                this.$modal.show('dialog', {
                    title: this.$t('general_settings.messages.parent_event_set'),
                    text: this.$t('general_settings.messages.parent_event_message'),
                    buttons: [
                        {
                            title: this.$t('general.close'),
                            default: true,
                            class: 'btn btn-primary'
                        }
                    ]
                });
            } else {
                this.parentEventWarnShown = false;
            }
        },

        stage() {
            if (this.event.test_event) {
                delete this.innerValue.stage;
            } else {
                this.innerValue.stage = this.stage.value;
                this.innerValue.lifecycle.stage = this.stage.value;
            }
        },

        async containerApp(newValue, oldValue) {
            if (!newValue || newValue === oldValue) {
                return;
            }

            this.innerValue.branded_app = newValue;
            await this.updateBrandingWhitelist(newValue, oldValue);
            this.updateWhitelist();
        },

        whitelistBranding() {
            this.updateWhitelist();
        }
    },

    methods: {
        async init() {
            try {
                this.innerValue.eventname = this.event.eventname;

                const tz = this.event.timezone;
                this.innerValue.enddate = this.$utils.time.convertTimestampToHumanForm(this.event.description.end_time, tz);
                this.innerValue.startdate = this.$utils.time.convertTimestampToHumanForm(this.event.description.start_time, tz);

                this.innerValue.branding_whitelist = this.event.branding_whitelist;
                this.whitelistBranding = this.innerValue.branding_whitelist?.includes(this.event.branded_app);
                this.containerApp = this.event.branded_app;

                this.innerValue.webapp = this.event.webapp || {};
                this.innerValue.native = this.event.native || {};

                this.stage = this.stages.find(stage => stage.value === this.event.lifecycle.stage);

                if (this.event.based_on_template) {
                    const canReadTemplate = this.$services.user.hasPermission('node_crud_realms.read_event_data', {
                        event_id: this.event.based_on_template,
                        org_id: this.event.ownerId // whild gues the template might actually be from another org
                    });
                    try {
                        if (canReadTemplate) {
                            this.baseTemplate = await this.$services.event.getEvent(this.event.based_on_template);
                        }
                    } catch (error) {
                        console.info('[WorkspaceInfo] Cannot read template info, user has no access to the template', error);
                    }
                }

                this.isMembershipAppInstalled = await this.$services.market.isPackageInstalled(this.event._id, 'membership-app');

                if (this.showAdvancedOptionsFieldset) {
                    const events = await this.$services.user.getUserEvents();
                    this.userEvents = events.filter(e => e._id !== this.event._id);

                    if (!isEmpty(this.event.parent_event) && this.userEvents.length) {
                        this.parentEventWarnShown = true;
                        this.parentEvent = this.userEvents.find(e => e._id === this.event.parent_event);
                    }
                }

                if (!this.canAccessOrgData) {
                    if (this.event.description.hasOwnProperty('categories')) {
                        this.innerValue.description.categories = clone(this.event.description.categories);
                    }

                    if (this.event.description.hasOwnProperty('category')) {
                        this.innerValue.description.category = this.event.description.category;
                    }
                }

                await this.initOrgSelectionData();
                await this.initOrgData();

            } catch (error) {
                console.error('[WorkspaceInfo] Could not initialize component', error);
            } finally {
                this.ready = true;
            }
        },

        async initOrgSelectionData() {
            try {
                this.innerValue.ownerId = this.event.ownerId;

                if (!this.canChangeEventOwner) {
                    return;
                }

                const organizations = this.userIsAdminOrSupport ? await this.$services.org.getAllOrgs() : this.$services.user.getManagedOrgs();
                this.organizations = organizations.map(o => ({ label: o.display_name, value: o._id, _id: o._id }));
                let org = this.organizations.find(o => o.value === this.event.ownerId);
                if (!org) {
                    org = { label: this.$services.org.getDisplayName(this.event.ownerId), value: this.event.ownerId };
                    this.orgDisabled = !this.userIsAdminOrSupport;
                }

                this.org = org;

            } catch (error) {
                console.error('[WorkspaceInfo] Could not initialize org slect data', error);
            } finally {
                this.orgsLoading = false;
            }
        },

        async initOrgData() {
            try {
                if (!this.canAccessOrgData) {
                    return;
                }

                const orgName = this.$services.org.getNameFromId(this.orgId);
                const orgData = await this.$services.org.getOrg(orgName);
                this.organization = orgData;

                this.isCategoryEnabled = get(orgData, 'workspace_defaults.enable_category', false);
                const hasMultiCategory = get(orgData, 'workspace_defaults.category_multiselect', false);

                if (hasMultiCategory) {
                    this.category = this.event.description?.categories || [];
                } else {
                    this.category = this.event.description?.category;
                }

            } catch (error) {
                console.error('[WorkspaceInfo] Could not initialize org data', error);
            }
        },

        updateWhitelist() {
            this.innerValue.branding_whitelist = this.whitelistBranding ? [this.innerValue.branded_app] : [];
        },

        async updateBrandingWhitelist(brandingId, oldBrandingId) {
            if (!brandingId) {
                brandingId = this.innerValue.branded_app;
            }

            this.forceWhiteListBranding = false;
            const currentBranding = await this.$services.branding.getBranding(brandingId);

            // first make sure the configuration will not remove users from the app
            if (get(currentBranding, 'invitations_config.only_whitelisted_events') === true) {
                this.forceWhiteListBranding = true;

                if (!this.whitelistBranding) {
                    // case of changing the branding: revert
                    if (oldBrandingId && brandingId !== oldBrandingId) {
                        this.containerApp = oldBrandingId;

                        this.$modal.show('dialog', {
                            title: this.$t('general_settings.messages.unusable_container_title'),
                            text: this.$t('general_settings.messages.unusable_container_message'),
                            buttons: [
                                {
                                    title: this.$t('general.close'),
                                    default: true,
                                    class: 'btn btn-primary'
                                }
                            ]
                        });

                        return;
                    }

                    // initial load: just a warning, so remove forceWhiteListBranding so this can be adjusted
                    this.forceWhiteListBranding = false;

                    this.$modal.show('dialog', {
                        title: this.$t('general_settings.messages.wrong_container_title'),
                        text: this.$t('general_settings.messages.wrong_container_message'),
                        buttons: [
                            {
                                title: this.$t('general.close'),
                                default: true,
                                class: 'btn btn-primary'
                            }
                        ]
                    });
                }
            }
        },

        promptConversionConfirmation() {
            this.$modal.show('dialog', {
                text: this.$t('general_settings.messages.preprod_confirmation'),
                buttons: [
                    {
                        title: this.$t('general.dismiss'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general_settings.actions.move_to_preprod'),
                        handler: async () => {
                            await this.convertToPreprod();
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        async convertToPreprod() {
            try {
                await this.$services.event.convertWorkspaceToProduction(this.event);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('general_settings.messages.conversion_success').toString(),
                    type: 'success',
                    duration: 5000
                });

                this.$modal.show(Dialog, {
                    text: this.$t('general_settings.messages.reload_confirm'),
                    buttons: [{
                        title: this.$t('general.reload'),
                        default: true,
                        handler: () => window.location.reload(),
                        class: 'btn'
                    }],
                }, {
                    classes: 'small',
                    reset: true,
                    clickToClose: false,
                    height: 'auto'
                });

                // Since now we don't need the "test" stage placeholder,
                // we remove it from the available options
                this.stages = this.stages.filter(s => s._id !== 'sandbox');
            } catch (error) {
                console.error('[WorkspaceInfo] Could not convert the event to pre-prod', error);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('general_settings.messages.conversion_failure').toString(),
                    type: 'error',
                    duration: 5000
                });
            }
        },

        preSubmitHook() {
            this.innerValue.bs_owner_id = this.innerValue.ownerId;
            delete this.innerValue.ownerId;

            const tz = this.event.timezone;

            if (tz) {
                this.innerValue.description.start_time = this.$utils.time.convertDateStringToUTCTimestamp(this.innerValue.startdate, tz);
                this.innerValue.description.end_time = this.$utils.time.convertDateStringToUTCTimestamp(this.innerValue.enddate, tz);
            }
        },

        setApps(apps) {
            this.apps = apps;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"workspace-info",attrs:{"tag":"form","autocomplete":"off"}},[_c('fieldset',{staticClass:"general-data"},[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.workspace_data')))]),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"eventname"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{staticClass:"eventname",attrs:{"type":"text","name":"eventname","disabled":!_vm.canChangeSettings,"label":_vm.$t('general_settings.form.eventname'),"errors":errors},model:{value:(_vm.innerValue.eventname),callback:function ($$v) {_vm.$set(_vm.innerValue, "eventname", $$v)},expression:"innerValue.eventname"}})]}}])}),_c('div',{staticClass:"grouped-controls"},[_c('div',{staticClass:"form-groups"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"startdate"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('datetime-picker',{ref:"startdate",attrs:{"type":"datetime","name":"startdate","value-type":"format","label":_vm.$t('general_settings.form.startdate'),"show-second":false,"minute-step":30,"disabled":!_vm.canChangeStartDate,"not-before":_vm.minStartDate,"not-after":_vm.innerValue.enddate,"format":_vm.$const.DEFAULT_DATETIME_FORMAT,"errors":errors},model:{value:(_vm.innerValue.startdate),callback:function ($$v) {_vm.$set(_vm.innerValue, "startdate", $$v)},expression:"innerValue.startdate"}})]}}])}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"enddate"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('datetime-picker',{ref:"enddate",attrs:{"type":"datetime","name":"enddate","value-type":"format","label":_vm.$t('general_settings.form.enddate'),"show-second":false,"minute-step":30,"disabled":!_vm.innerValue.startdate || !_vm.canChangeEndDate || !_vm.canChangeSettings,"not-before":_vm.innerValue.startdate,"not-after":_vm.maxEndDate,"format":_vm.$const.DEFAULT_DATETIME_FORMAT,"default-value":_vm.innerValue.startdate,"errors":errors},model:{value:(_vm.innerValue.enddate),callback:function ($$v) {_vm.$set(_vm.innerValue, "enddate", $$v)},expression:"innerValue.enddate"}})]}}])})],1)]),(_vm.event.test_event && _vm.canChangeStatusFromTestToPreprod && _vm.ready)?[_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('general_settings.form.stage_test_tip')),expression:"$t('general_settings.form.stage_test_tip')"}]},[_vm._v(_vm._s(_vm.$t('general_settings.form.stage')))]),_c('div',{staticClass:"alert alert-warning"},[_c('p',[_vm._v(_vm._s(_vm.$t('general_settings.form.stage_test')))]),_c('button',{staticClass:"btn btn-warn",attrs:{"type":"button"},on:{"click":_vm.promptConversionConfirmation}},[_vm._v(_vm._s(_vm.$t('general_settings.actions.move_to_preprod')))])])])]:_vm._e(),(!_vm.event.test_event)?[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"stage"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{ref:"stage",attrs:{"name":"stage","track-by":"_id","label":_vm.$t('general_settings.form.stage'),"disabled":!_vm.canChangeSettings,"tip":_vm.$t('general_settings.form.stage_tip'),"allow-empty":false,"options":_vm.stages,"errors":errors},model:{value:(_vm.stage),callback:function ($$v) {_vm.stage=$$v},expression:"stage"}})]}}],null,false,525158167)})]:_vm._e(),(_vm.canChangeContainerApp && _vm.ready)?[_c('div',{staticClass:"related-controls"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"branded_app"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('app-container-picker',{ref:"container_app",attrs:{"disabled":!_vm.canChangeSettings,"errors":errors,"label":_vm.$t('general_settings.form.container_app'),"org":_vm.orgId,"placeholder":_vm.$t('general_settings.form.container_app_placeholder'),"only-non-unique-email-apps":_vm.event.allow_non_unique_email,"name":"branded_app","open-direction":"below"},on:{"loaded":_vm.setApps},model:{value:(_vm.containerApp),callback:function ($$v) {_vm.containerApp=$$v},expression:"containerApp"}})]}}],null,false,1923937588)}),_c('validation-provider',{attrs:{"slim":true}},[_c('checkbox',{attrs:{"name":"whitelistBranding","disabled":!_vm.innerValue.branded_app || _vm.forceWhiteListBranding || !_vm.canChangeSettings,"tip":_vm.forceWhiteListBranding ? _vm.$t('general_settings.form.container_app_hint') : null,"label":_vm.$t('general_settings.form.white_list_branding')},model:{value:(_vm.whitelistBranding),callback:function ($$v) {_vm.whitelistBranding=$$v},expression:"whitelistBranding"}})],1)],1)]:(_vm.containerAppObj)?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('general_settings.form.container_app')))]),_c('div',{staticClass:"alert alert-info"},[_c('div',[_vm._v(_vm._s(_vm.containerAppObj.label))]),_c('div',[_c('small',[_vm._v(_vm._s(_vm.whitelistBranding ? _vm.$t('general_settings.form.white_list_branding') : _vm.$t('general_settings.form.white_list_branding_positive')))])])])])]:_vm._e(),(_vm.canChangeEventOwner && _vm.canChangeSettings && !_vm.orgDisabled)?[_c('loader',{staticClass:"in-page form-group medium",attrs:{"status":_vm.orgsLoading}},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"ownerId"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{ref:"org",attrs:{"name":"ownerId","track-by":"_id","label":_vm.$t('general_settings.form.organization'),"allow-empty":false,"options":_vm.organizations,"errors":errors},model:{value:(_vm.org),callback:function ($$v) {_vm.org=$$v},expression:"org"}})]}}],null,false,958614577)})],1),(_vm.orgHasChanged)?_c('div',{staticClass:"alert alert-warning"},[_c('p',[_vm._v(_vm._s(_vm.$t('general_settings.messages.org_changed')))])]):_vm._e()]:(_vm.ready)?[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('general_settings.form.organization')))]),_c('div',{staticClass:"alert alert-info"},[_vm._v(_vm._s(_vm.event.ownerName || _vm.$services.org.getDisplayName(_vm.event.ownerId)))])])]:_vm._e(),(_vm.isCategoryEnabled)?[_c('validation-provider',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('workspace-category',{attrs:{"organization":_vm.organization,"name":"categories","disabled":!_vm.canChangeSettings,"errors":errors},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})]}}],null,false,2739063027)})]:_vm._e()],2),_c('fieldset',{staticClass:"app_access"},[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.app_access.title')))]),_c('validation-provider',{staticClass:"webapp_access",attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"close_access_webapp","disabled":!_vm.canChangeSettings,"hint":_vm.$t('general_settings.form.close_access_webapp_hint'),"off-label":_vm.$t('general_settings.form.close_access_webapp'),"on-label":_vm.$t('general_settings.form.close_access_webapp')},model:{value:(_vm.innerValue.webapp.is_closed),callback:function ($$v) {_vm.$set(_vm.innerValue.webapp, "is_closed", $$v)},expression:"innerValue.webapp.is_closed"}}),(_vm.innerValue.webapp.is_closed)?_c('div',{staticClass:"feature-dependant"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"redirect_url"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.$t('general_settings.form.redirect_url'),"disabled":false,"name":"redirect_url","errors":errors},model:{value:(_vm.innerValue.webapp.closed_redirect_url),callback:function ($$v) {_vm.$set(_vm.innerValue.webapp, "closed_redirect_url", $$v)},expression:"innerValue.webapp.closed_redirect_url"}})]}}],null,false,1198684142)})],1):_vm._e()],1),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"close_access_native","disabled":!_vm.canChangeSettings,"hint":_vm.$t('general_settings.form.close_access_native_hint'),"off-label":_vm.$t('general_settings.form.close_access_native'),"on-label":_vm.$t('general_settings.form.close_access_native')},model:{value:(_vm.innerValue.native.is_closed),callback:function ($$v) {_vm.$set(_vm.innerValue.native, "is_closed", $$v)},expression:"innerValue.native.is_closed"}})],1)],1),(_vm.canChangeSettings)?_c('fieldset',{staticClass:"templating"},[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.templating.title')))]),(_vm.baseTemplate)?_c('div',{staticClass:"alert alert-info"},[_c('p',[_vm._v(_vm._s(_vm.$t('general_settings.templating.based_on'))),_c('strong',[_c('a',{attrs:{"href":_vm.$services.event.getEventUrl(_vm.baseTemplate),"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$utils.workspaces.getWorkspaceTitle(_vm.baseTemplate, _vm.$i18n.locale))+"\n("+_vm._s(_vm.$services.org.getDisplayName(_vm.baseTemplate.ownerId))+")")])])])]):_vm._e(),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.redirectToTemplate()}}},[_vm._v(_vm._s(_vm.$t('general_settings.actions.create_template')))]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('general_settings.messages.create_template')))])])]):_vm._e(),(_vm.event.allow_non_unique_email)?_c('fieldset',{staticClass:"users"},[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.users.title')))]),_c('div',{staticClass:"alert alert-info"},[_c('p',[_vm._v(_vm._s(_vm.$t('general_settings.users.non_unique_emails_allowed')))])])]):_vm._e(),(_vm.showAdvancedOptionsFieldset)?_c('fieldset',{staticClass:"advanced"},[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.advanced.title')))]),(_vm.showParentContainerAppOption)?_c('validation-provider',{attrs:{"slim":true}},[_c('base-select',{ref:"parentEvent",attrs:{"name":"parentEvent","track-by":"_id","label":_vm.$t('general_settings.form.parent_event'),"tip":_vm.$t('general_settings.form.parent_event_tip'),"options":_vm.userEvents,"disabled":!_vm.canChangeSettings,"custom-label":function (item) { return _vm.$utils.workspaces.getWorkspaceTitle(item, _vm.$i18n.locale); }},model:{value:(_vm.parentEvent),callback:function ($$v) {_vm.parentEvent=$$v},expression:"parentEvent"}})],1):_vm._e()],1):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WorkspaceInfo.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__